function parallax () {
    const parallax = document.querySelectorAll('[data-parallax]');

    if(parallax.length > 0) {
        parallax.forEach(el=> {
            document.addEventListener('mousemove', (e)=> {
                let speed = el.getAttribute('data-speed');
                el.style.transform = `translate(${e.clientX / speed}px)`;
            });
        });
    }
}

export default parallax;